import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDishTypeList = styled(Box, {
	shouldForwardProp: (prop) => prop !== "isLargeOrder",
})<
	BoxProps & {
		isLargeOrder?: boolean;
	}
>(({ theme, isLargeOrder }) => ({
	...(isLargeOrder && {
		maskImage: "linear-gradient(to bottom, black calc(100% - 45px), transparent 100%)",
		paddingBottom: theme.spacing(5),
	}),
	display: "flex",
	width: "100%",
	height: "100%",
	flexDirection: "column",
	gap: theme.spacing(1),
	overflow: "auto",
}));
